// @flow
import React from 'react';
import { gridColumns } from './../Grid';
import { classNames } from '../../helpers/strings';

type GridColumnProps = {
  columnWidth?: string,
  smallColumnWidth?: string,
  spacer?: string,
  className?: string,
  children?: any,
  noPad?: boolean,
};

const GridColumn = ({
  columnWidth,
  smallColumnWidth,
  spacer,
  className = '',
  children,
  noPad,
}: GridColumnProps) => (
  <div
    className={classNames(
      `grid-column--${columnWidth || '12'}-${gridColumns}`,
      `grid-column--sm-${smallColumnWidth || '12'}-${gridColumns}`,
      spacer !== '0' ? `grid-spacer--${spacer || 0}` : '',
      noPad === true ? 'grid-column--no-pad' : '',
      className,
    )}
  >
    {children}
  </div>
);

GridColumn.defaultProps = {
  columnWidth: '',
  smallColumnWidth: '',
  spacer: '',
  className: '',
  children: null,
  noPad: false,
};

export default GridColumn;



// WEBPACK FOOTER //
// ./src/components/GridColumn/index.js